import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=badb2dbc&scoped=true&lang=html"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badb2dbc",
  null
  
)

export default component.exports